import { AboutPage } from '@/components/about/about-page';

export function About() {
  return <AboutPage />;
}